import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from 'js-cookie';

export const supplierApi = createApi({
  reducerPath: "supplier",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
    prepareHeaders: (headers, { getState }) => {
      const { auth } = getState();
      const token = auth.user.token
      headers.set('Authorization', `Bearer ${token}`);
      headers.set('Content-Type', `application/json;charset=UTF-8`);
      return headers;
    },
  }),
  tagTypes: ["supplier", "supplierCategories", "supplierProducts", "requisitions"],
  endpoints: (builder) => ({
    supplierList: builder.query({
      query: (data) => {
          return {
              url: "/Supplier/GetSuppliers",
              method: "GET",
              params: data
          }
      },
      providesTags: ["supplier"],
    }),
    supplierByName: builder.query({
      query: (data) => {
          return {
              url: "/Supplier/GetSuppliers",
              method: "GET",
              params: data
          }
      },
      providesTags: ["supplier"],
    }),
    supplierById: builder.query({
        query: (data) => {
            return {
                url: "/Supplier/GetSuppliers",
                method: "GET",
                params: data
            }
        },
        providesTags: ["supplier"],
    }),
    createSupplier: builder.mutation({
        query: (data) => {
          return {
            url: "/Supplier/CreateSupplier",
            method: "POST",
            body: data,
          };
        },
        invalidatesTags: ["supplier"],
    }),
    updateSupplier: builder.mutation({
        query: (data) => {
          return {
            url: "/Supplier/updateSupplier",
            method: "POST",
            body: data,
          };
        },
        invalidatesTags: ["supplier"],
    }),
    changeSupplierStatus: builder.mutation({
      query: (data) => {
        return {
          url: `/Supplier/UpdateSupplierStatus`,
          method: "POST",
          body: data
        };
      },
      invalidatesTags: ["supplier"],
    }),
    deleteSupplier: builder.mutation({
        query: (data) => {
          return {
            url: `/Supplier/DeleteSupplier?keyID=${data}`,
            method: "POST",
          };
        },
        invalidatesTags: ["supplier"],
    }),

    


    supplierCategory: builder.query({
        query: (data) => {
            return {
                url: "/Supplier/GetSupplierCategories",
                method: "GET",
                params: data
            }
        },
        providesTags: ["supplierCategories"],
    }),
    supplierCategoryByName: builder.query({
      query: (data) => {
          return {
              url: "/Supplier/GetSupplierCategories",
              method: "GET",
              params: data
          }
      },
      providesTags: ["supplierCategories"],
    }),
    createSupplierCategory: builder.mutation({
        query: (data) => {
          return {
            url: "/Supplier/CreateSupplierCategory",
            method: "POST",
            body: data,
          };
        },
        invalidatesTags: ["supplierCategories"],
    }),
    updateSupplierCategory: builder.mutation({
        query: (data) => {
          return {
            url: "/Supplier/UpdateSupplierCategory",
            method: "POST",
            body: data,
          };
        },
        invalidatesTags: ["supplierCategories"],
    }),
    deleteSupplierCategory: builder.mutation({
      query: (data) => {
        return {
          url: `/Supplier/DeleteSupplierCategory?keyID=${data}`,
          method: "POST",
        };
      },
      invalidatesTags: ["supplierCategories"],
    }),
    changeSupplierCategoryStatus: builder.mutation({
      query: (data) => {
        return {
          url: `/Supplier/UpdateSupplierCategoryStatus`,
          method: "POST",
          body: data
        };
      },
      invalidatesTags: ["supplierCategories"],
    }),


    supplierProducts: builder.query({
        query: (data) => {
            return {
                url: "/Supplier/GetSupplierProducts",
                method: "GET",
                params: data
            }
        },
        providesTags: ["supplierProducts"],
    }),
    supplierProductById: builder.query({
      query: (data) => {
          return {
              url: "/Supplier/GetSupplierProducts",
              method: "GET",
              params: data
          }
      },
      providesTags: ["supplierProducts"],
    }),
    createSupplierProduct: builder.mutation({
        query: (data) => {
          return {
            url: "/Supplier/CreateSupplierProduct",
            method: "POST",
            body: data,
          };
        },
        invalidatesTags: ["supplierProducts"],
    }),
    updateSupplierProduct: builder.mutation({
        query: (data) => {
          return {
            url: "/Supplier/UpdateSupplierProduct",
            method: "POST",
            body: data,
          };
        },
        invalidatesTags: ["supplierProducts"],
    }),
    deleteSupplierProduct: builder.mutation({
      query: (data) => {
        return {
          url: `/Supplier/DeleteSupplierProduct?keyID=${data}`,
          method: "POST",
        };
      },
      invalidatesTags: ["supplierProducts"],
    }),
    changeSupplierProductStatus: builder.mutation({
      query: (data) => {
        return {
          url: `/Supplier/UpdateSupplierProductsStatus`,
          method: "POST",
          body: data
        };
      },
      invalidatesTags: ["supplierProducts"],
    }),


    supplierInvoiceDetails: builder.query({
        query: (data) => {
            return {
                url: "/Supplier/GetSupplierInvoiceDetails",
                method: "GET",
                params: data
            }
        },
        providesTags: ["requisitions"],
    }),
    createService: builder.mutation({
      query: (data) => {
        return {
          url: "/Service/createProductOrService",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["services/products", "requisitions"],
    }),
    supplierInvoiceById: builder.query({
      query: (data) => {
          return {
              url: "/Supplier/GetSupplierInvoiceDetails",
              method: "GET",
              params: data
          }
      },
      providesTags: ["requisitions"],
    }),
    createSupplierInvoice: builder.mutation({
      query: (data) => {
        return {
          url: "/Supplier/createSupplierInvoiceDetails",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["requisitions"],
    }),
    updateSupplierInvoice: builder.mutation({
      query: (data) => {
        return {
          url: "/Supplier/UpdateSupplierInvoice",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["requisitions"],
    }),
    deleteSupplierInvoice:builder.mutation({
      query: (data) => {
        return {
          url: `/Supplier/DeleteSupplierInvoiceItem?keyID=${data}`,
          method: "POST",
        };
      },
      invalidatesTags: ["requisitions"],
    }),
    createStockLog: builder.mutation({
      query: (data) => {
        return {
          url:  "/Service/createStockLog",
          method: "POST",
          body: data
        };
      },
      invalidatesTags: ["requisitions"],
    }),
    updateRequisitionStatus: builder.mutation({
      query: (data) => {
        return {
          url:  "/Supplier/UpdateRequisitionStatus",
          method: "POST",
          body: data
        };
      },
      invalidatesTags: ["requisitions"],
    }),
  }),
});

export const { 
  useSupplierListQuery,
  useSupplierByNameQuery,
  useSupplierByIdQuery,
  useCreateSupplierMutation,
  useUpdateSupplierMutation,
  useChangeSupplierStatusMutation,
  useDeleteSupplierMutation,

  useDeleteSupplierCategoryMutation,
  useChangeSupplierCategoryStatusMutation,
  useSupplierCategoryQuery,
  useSupplierCategoryByNameQuery,
  useCreateSupplierCategoryMutation,
  useUpdateSupplierCategoryMutation,

  useSupplierProductsQuery,
  useSupplierProductByIdQuery,
  useCreateSupplierProductMutation,
  useUpdateSupplierProductMutation,
  useDeleteSupplierProductMutation,
  useChangeSupplierProductStatusMutation,

  useSupplierInvoiceDetailsQuery,
  useCreateServiceMutation,
  useSupplierInvoiceByIdQuery,
  useCreateSupplierInvoiceMutation,
  useUpdateSupplierInvoiceMutation,
  useDeleteSupplierInvoiceMutation,
  useCreateStockLogMutation,
  useUpdateRequisitionStatusMutation
} = supplierApi;
